import { TermoAditivo } from '../../modules/types/Aquisicao';
import httpClient from '../httpClient';
export async function getAllTermosAditivosPorEntidade(tab: string, id: number) {
  try {
    const response = await httpClient.get(`/api/termoaditivo/porentidade`, {
      params: {
        tab,
        id,
      },
    });
    return Array.isArray(response.data.registros)
      ? response.data.registros
      : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de Registros: ' + error);
  }
}

export async function handleCreate(form: TermoAditivo, tab: string) {
  try {
    return await httpClient.post(`/api/termoaditivo?tab=${tab}`, form);
  } catch (error) {
    throw error;
  }
}

export async function handleUpdate(form: TermoAditivo) {
  try {
    const response = await httpClient.patch(
      `/api/termoaditivo/${form.id}`,
      form,
    );

    return response;
  } catch (error) {
    throw error;
  }
}

export async function handleDelete(id: string | number) {
  try {
    return await httpClient.delete(`/api/termoaditivo/${id}`);
  } catch (error) {
    throw error;
  }
}

export async function getTiposByTermoAditivoId(termoAditivoId: number) {
  try {
    const response = await httpClient.get(
      `/api/termoaditivo/${termoAditivoId}/tipos`,
    );

    return response.data.registros || [];
  } catch (error) {
    throw new Error('Erro ao obter tipos do Termo Aditivo: ' + error);
  }
}

export async function getAllTipoTermoAditivo() {
  try {
    const response = await httpClient.get(`/api/tipotermoaditivo`);
    return Array.isArray(response.data.registros)
      ? response.data.registros
      : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de registros: ' + error);
  }
}
